import { render, staticRenderFns } from "./MainColumnAdd.vue?vue&type=template&id=1295fae2&scoped=true&"
import script from "./MainColumnAdd.vue?vue&type=script&lang=js&"
export * from "./MainColumnAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295fae2",
  null
  
)

export default component.exports